import Component from './Bulk';

export default Component;
